import { encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import { message } from "antd";
import config from "../config";
import { getCached, setCached } from "./cacheStore";


class StoppageReportStore {
  stoppageReport = [];
  stoppageArray = []
  total = 0;
  totalStoppageReportTotal = 0
  loading = false;
  loadingData = false
  pageSize = 0

  rootStore;


  constructor(rootStore) {
    makeObservable(this, {
      stoppageReport: observable,

      pageSize: observable,
      stoppageArray: observable,
      total: observable,
      loading: observable,
      loadingData: observable,
      totalStoppageReportTotal: observable,

      loadData: action,
      exportExcel: action,
      exportpdf: action,
      exportcsv: action,
      exportxml: action,
      totalStoppageReport: action
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    vehicleId,
    toDate,
    fromDate,
    interval,
    pageNo,
    allVehicleIds
  }) {
    var response
    const cacheKey = `stoppagereportlist:${companyId}:${vehicleId}:${allVehicleIds}:${fromDate}:${toDate}:${interval}:${offset}:${limit}`;
    const cached = getCached(cacheKey);
    if (cached) {
      this.total = cached.total;
      this.stoppageReport = cached.reportData;
      return;
    }
    this.loading = true;
    var postData = { "companyId": companyId, "vehicleId": vehicleId, "interval": interval, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": pageNo }

    if (config.pythonReport == 1) {
      response = await postApi.getClient("report").post("/tracking_report/stoppage", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=vehicle&a=stopreport", "postData=" + base64Input);
    }

    const reportData = response?.data?.data?.StopData ?? []
    const total = parseInt(response?.data?.data?.TotalCount)
    const pageSize = response?.data?.data?.StopData?.length

    setCached(cacheKey, { total, pageSize, reportData });

    this.total = total
    this.pageSize = pageSize
    this.stoppageReport = reportData
    this.loading = false
    // this.stoppageReport = response?.data?.data?.StopData;
    // this.pageSize = response?.data?.data?.StopData?.length
    // this.total = parseInt(response?.data?.data?.TotalCount);
    // this.loading = false;

  }

  async totalStoppageReport({
    companyId,
    offset,
    limit,
    vehicleId,
    toDate,
    fromDate,
    interval,
    pageNo
  }) {
    var response
    const cacheKey = `totalStoppagereportlist:${companyId}:${vehicleId}${fromDate}:${toDate}:${interval}:${offset}:${limit}:${pageNo}`;
    const cached = getCached(cacheKey);
    if (cached) {
      this.totalStoppageReportTotal = cached.total;
      this.stoppageArray = cached.reportData;
      return;
    }
    this.loadingData = true;
    var postData = { "companyId": companyId, "vehicleId": vehicleId, "interval": interval, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, total: true }

    if (config.pythonReport == 1) {
      response = await postApi.getClient("report").post("/tracking_report/stoppage", postData);
      // this.stoppageArray = response?.data?.data?.StopData;
      const reportData = response?.data?.data?.StopData ?? []
      const total = parseInt(response?.data?.data?.TotalCount);
      setCached(cacheKey, { reportData, total });

      this.totalStoppageReportTotal = total
      this.stoppageArray = reportData
    }
    else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=vehicle&a=totalStopageReport", "postData=" + base64Input);
      this.stoppageArray = response?.data?.data;
    }

    this.loadingData = false;

  }

  async exportExcel(getData) {

    if (config.pythonReport === 1) {



      try {
        await postApi.getClient("report").post("/tracking_report/stoppage/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportstopexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportpdf(getData) {

    if (config.pythonReport === 1) {


      try {
        await postApi.getClient("report").post("/tracking_report/stoppage/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.");
      }

    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportstoppdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportstopcsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportstopxml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
}

export default StoppageReportStore;
